module.exports = __webpack_public_path__ + "static/img/preview-05.c5cf1d10.webp";